<template>
  <div>
    <div class="org-username">
        <user-icon :logoPath="row.BeUserLogo || row.UserLogo"></user-icon>
        <span>{{row.Name || row.BeCompName}}</span>
    </div>
    <span class="org-sub" v-if="row.UserID == 0">的所有人</span>
  </div>
</template>

<script>
import UserIcon from '/@/components/icon/user-icon.vue';

export default {
  props: {
    row: Object
  },
  components: {UserIcon}
};
</script>

<style lang="less" scoped>
.org-sub {
  display: block;
  font-size: 12px;
  color: #999;
  margin-left: 24px;
  line-height: 1;
}
.org-username{
    font-size: 14px;
    color: @main-color;
    display: flex;
    align-items: center;
    /deep/ img{
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
  }
</style>